export default "../css/8583bd6fce14da34ea436d80ec22aa61.ttf";